// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pg_a bhc_cw bhc_jx bhc_jo bhc_a bhc_j bhc_ri bhc_rj","SearchPanel__icon":"pg_b bhc_ui bhc_hb bhc_ro bhc_tu","SearchPanel__input":"pg_c bhc_iv bhc_cx bhc_z"};